// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"65b3651c","36":"65b3651c","88":"c3873069","120":"df90296c","124":"7fba99b3","132":"31d6cfe0","960":"3561c2ab"}[chunkId] + ".chunk.css";
};